<template>
    <div>
        <div class="maincategories-wrapper">
            <div class="categories-wrapper max-width">
                <div
                    v-for="category in categories"
                    :key="'mcat' + category.id"
                    @click="changeMain(category)"
                    class="category"
                    :class="{ active: category.id == main.id }"
                >
                    <img
                        class=""
                        :src="category.id == main.id ? category.icon_active : category.icon"
                    />
                    <span :title="category.title" class="category-title">
            {{ category.title || "" }}
          </span>
                </div>
            </div>
        </div>
        <div class="main-grid">
            <div class="main-wrapper">
                <div class="sidebar-filter"></div>

                <div class="main"></div>
            </div>

            <div class="grid-empty"></div>
            <div class="grid-title">
                <div class="category-heading">
                    {{ main.title || "" }}
                </div>
            </div>
            <div class="grid-filter-toggle" @click="toggleFilter()">
                Filter<img
                class="filter-carrot"
                :class="{ reverse: showFilter }"
                src="/img/icons/carrot.svg"
            />
            </div>
            <div
                class="grid-filter sidebar-filter"
                :class="{ hideFilter: !showFilter }"
            >
                <div class="filter-column">
                    <filter-age
                        v-model="filters.age"
                        :open="age_open"
                        @open="changeOpenAge"
                    />
                    <filter-cost
                        v-model="filters.cost"
                        :open="cost_open"
                        @open="changeOpenCost"
                    />
                    <filter-duration
                        @changeUnit="changeUnit"
                        v-model="filters.duration"
                        :open="duration_open"
                        @open="changeOpenDuration"
                    />
                    <filter-amount
                        @open="changeOpenAmount"
                        :open="amount_open"
                        v-model="filters.amount"
                    />
                    <filter-preperation
                        @open="changeOpenPrep"
                        :open="prep_open"
                        v-model="filters.preperation"
                    />
                    <filter-local
                        @open="changeOpenLocal"
                        :open="local_open"
                        :resetSignal="resetSignal"
                        v-model="filters.local"
                    />
                    <filter-infra
                        @open="changeOpenInfra"
                        :open="infra_open"
                        :resetSignal="resetSignal"
                        v-model="filters.infra"
                    />
                    <filter-geolocation
                        v-model="filters.geolocation"
                    ></filter-geolocation>
                    <filter-objectives
                        :open="objective_open"
                        :categories="objectiveFilters"
                        v-model="filters.objectives"
                        :resetObjective="objectiveSignal"
                        @resetSignal="objectiveSignal = false"
                    >
                    </filter-objectives>

                    <div class="reset-filter" @click.prevent="resetFilters()">
                        Filter zurücksetzen
                    </div>

                    <div @click="toggleMap()" class="filter-box map-toggle">
                        <img v-if="!mapView" src="/img/icons/map-pin-blue.svg"/>

                        {{ mapView ? "Zur Listenansicht" : "Zur Kartenansicht" }}
                    </div>
                </div>
            </div>
            <div class="grid-subs">
                <div class="main">
                    <div class="subcategories" v-if="subs.length > 0">
                        <div class="subcategories-row">
                            <div
                                :title="subcategory.title"
                                v-for="subcategory in subs"
                                :key="'sub' + subcategory.id"
                                class="subcategory"
                                :class="{
                  active: activeSub !== null && activeSub.id == subcategory.id,
                }"
                                @click="() => changeSub(subcategory)"
                            >
                                {{ subcategory.title }}
                            </div>
                            <div class="category-divider"></div>
                            <div
                                @click="() => changeSub({})"
                                class="subcategory"
                                :class="{
                  active:
                    activeSub === null ||
                    (Object.keys(activeSub).length === 0 &&
                      activeSub.constructor === Object),
                }"
                            >
                                Alle anzeigen
                            </div>
                        </div>
                        <div
                            class="subcategories-row-divider"
                            v-if="subsubs && subsubs.length > 0"
                        ></div>
                        <div
                            class="subcategories-row subsubcategories"
                            v-if="subsubs && subsubs.length > 0"
                        >
                            <div
                                v-for="subsubcategory in subsubs"
                                @click="() => changeSubSub(subsubcategory)"
                                :key="'subsub' + subsubcategory.id"
                                class="subsubcategory"
                                :class="{
                  active:
                    activeSubSub !== null &&
                    activeSubSub.id == subsubcategory.id,
                }"
                            >
                                {{ subsubcategory.title }}
                            </div>
                            <div class="category-divider"></div>
                            <div
                                @click="() => changeSubSub({})"
                                class="subcategory"
                                :class="{
                  active:
                    activeSubSub === null ||
                    (Object.keys(activeSubSub).length === 0 &&
                      activeSubSub.constructor === Object),
                }"
                            >
                                Alle anzeigen
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-grid">
                <div class="main">
                    <div>
                        <div v-if="!mapView" class="">
                            <div class="idea-controls">
                                <div class="idea-counter">{{ ideasAmount }}</div>
                                <div class="grid-toggler">
                                    <button @click.prevent="gridview = true">
                                        <img v-if="gridview" src="/img/icons/grid-orange.svg"/>
                                        <svg
                                            v-if="!gridview"
                                            id="apps"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                id="Pfad_72"
                                                data-name="Pfad 72"
                                                d="M10,13H3a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V14A.945.945,0,0,0,10,13ZM9,20H4V15H9ZM21,2H14a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V3A.945.945,0,0,0,21,2ZM20,9H15V4h5Zm1,4H14a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V14A.945.945,0,0,0,21,13Zm-1,7H15V15h5ZM10,2H3A.945.945,0,0,0,2,3v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V3A.945.945,0,0,0,10,2ZM9,9H4V4H9Z"
                                                fill="#0e5c84"
                                            />
                                            <rect
                                                id="Rechteck_116"
                                                data-name="Rechteck 116"
                                                width="24"
                                                height="24"
                                                fill="none"
                                            />
                                        </svg>

                                        <!-- <img v-if="!gridview" src="/img/icons/grid-blue.svg" /> -->
                                    </button>
                                    <button @click.prevent="gridview = false">
                                        <img v-if="gridview" src="/img/icons/list-blue.svg"/>

                                        <svg
                                            v-if="!gridview"
                                            id="List"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                id="Pfad_72"
                                                data-name="Pfad 72"
                                                d="M21,13H3a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1H21a.945.945,0,0,0,1-1V14A.945.945,0,0,0,21,13Zm-1,7H4V15H20ZM21,2H3A.945.945,0,0,0,2,3v7a.945.945,0,0,0,1,1H21a.945.945,0,0,0,1-1V3A.945.945,0,0,0,21,2ZM20,9H4V4H20Z"
                                                fill="#f0693a"
                                            />
                                            <rect
                                                id="Rechteck_116"
                                                data-name="Rechteck 116"
                                                width="24"
                                                height="24"
                                                fill="none"
                                            />
                                        </svg>

                                        <!-- <img v-if="!gridview" src="/img/icons/list-orange.svg" /> -->
                                    </button>
                                </div>
                            </div>
                            <div class="ideas-grid" v-if="gridview">
                                <idea-grid-item
                                    v-for="idea in ideas"
                                    :idea="idea"
                                    :key="idea.title + idea.id"
                                />
                            </div>
                            <div class="ideas-list" v-if="!gridview">
                                <idea-list-item
                                    v-for="idea in ideas"
                                    :idea="idea"
                                    :key="idea.title + idea.id"
                                />
                            </div>
                            <infinite-loading
                                ref="infiniteLoading"
                                @infinite="infiniteHandler"
                            >
                                <div slot="no-more">Alle Ideen geladen</div>
                                <div slot="no-results">Keine Treffer</div>
                            </infinite-loading
                            >
                        </div>
                        <idea-map
                            @toggle="turnOffMap"
                            :mapPosition="filters.geolocation"
                            :filters="filters"
                            v-if="mapView"
                        ></idea-map>
                    </div>
                </div>
                <!-- <div class="sidebar-filter"> -->
                <!-- <idea-filters> </idea-filters> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        "classes",
        "categories",
        "mainCategory",
        "mainSub",
        "mainSubSub",
        "startMap",
        "startLat",
        "startLng",
        "objectiveFilters"

    ],
    data() {
        return {
            duration_open: undefined,
            age_open: undefined,
            cost_open: undefined,
            amount_open: undefined,
            prep_open: undefined,
            local_open: undefined,
            infra_open: undefined,
            objective_open: undefined,
            objectiveSignal: false,
            resetSignal: false,
            showFilter: false,
            // activeMain: {},
            mapView: false,
            activeSub: this.mainSub ?? null,
            activeSubSub: this.mainSubSub ?? null,
            main: this.mainCategory,
            mainS: this.mainSub ?? null,
            mainSS: this.mainSubSub ?? null,
            subs: [],
            subsubs: [],
            ideas: [],
            ideasTotal: 0,
            page: 1,
            gridview: true,
            duration_unit: "0",
            filters: {
                category: {
                    main: this.mainCategory.id,
                    sub: this.mainSub ? this.mainSub.id : null,
                    subsub: this.mainSubSub ? this.mainSubSub.id : null,
                },
                age: null,
                cost: null,
                duration: null,
                preperation: null,
                local: null,
                infra: null,
                amount: null,
                date: null,
                location: null,
                geolocation: null,
                objectives: null,
            },
        };
    },
    watch: {
        "filters.age": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.cost": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.duration": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.amount": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.preperation": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.local": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.infra": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.objectives": function (newData, oldData) {
            this.debounceFilter();
        },
        "filters.geolocation": function (newData, oldData) {
            this.debounceFilter();
        },
    },
    methods: {
        changeOpenAge(val) {
            this.age_open = val;
        },
        changeOpenCost(val) {
            this.cost_open = val;
        },
        changeOpenDuration(val) {
            this.duration_open = val;
        },
        changeOpenAmount(val) {
            this.amount_open = val;
        },
        changeOpenPrep(val) {
            this.prep_open = val;
        },
        changeOpenLocal(val) {
            this.local_open = val;
        },
        changeOpenInfra(val) {
            this.infra_open = val;
        },
        changeOpenObjectives(val) {
            this.objective_open = val;
        },
        changeUnit(val) {
            this.duration_unit = val;

            if (val === "1") {
                this.filters.duration = [1, 4];
            } else {
                this.filters.duration = [
                    Math.floor(this.filters.duration[0]),
                    Math.floor(this.filters.duration[1]),
                ];
            }
            // console.log("after change", this.filters.duration);
            this.duration_unit = val;
        },
        toggleMap() {
            this.mapView = !this.mapView;
            if (!this.mapView) {
                delete this.filters.map;
                // this.debounceFilter();
            }
        },
        turnOffMap() {
            this.mapView = false;
        },
        toggleFilter() {
            this.showFilter = !this.showFilter;
        },
        resetFilters() {
            this.filters = {
                category: {
                    main: this.mainCategory.id,
                    sub: this.mainSub ? this.mainSub.id : null,
                    subsub: this.mainSubSub ? this.mainSubSub.id : null,
                },
                age: null,
                cost: null,
                duration: null,
                preperation: null,
                local: null,
                infra: null,
                objectives: null,
                amount: null,
                date: null,
                location: null,
                geolocation: null,
            };
            this.duration_unit = "0";
            this.duration_open = undefined;
            this.age_open = undefined;
            this.cost_open = undefined;
            this.amount_open = undefined;
            this.prep_open = undefined;
            this.local_open = undefined;
            this.infra_open = undefined;
            this.objective_open = undefined;
            this.objectiveSignal = true;
            this.resetSignal = true;
            setTimeout(() => {
                this.resetSignal = false;
            }, 1000);
            document.querySelector(".ap-input").value = "";
        },
        async infiniteHandler($state) {
            let tmp = _.cloneDeep(this.filters);
            console.log("copy", tmp);
            console.log(this.filters);
            if (this.duration_unit == "1") {
                tmp.duration = [
                    this.filters.duration[0] * 60,
                    this.filters.duration[1] * 60,
                ];
            }
            // console.log("INFINITE HANDLER CALLED", tmp, this.page);
            const {data} = await axios.get("/api/ideas", {
                params: {filters: tmp, page: this.page},
            });
            // console.log("RES", data);
            if (data.ideas.data.length < 1) {
            }
            if (this.page <= data.ideas.last_page) {
                this.ideasTotal = data.ideas.total;
                this.page = this.page + 1;
                this.ideas.push(...data.ideas.data);
                $state.loaded();
            } else {
                $state.complete();
            }
        },
        toggleView() {
            this.gridview = !this.gridview;
        },

        changeMain(category) {
            this.main = category;
            this.subs = category.subcategory;
            this.subsubs = []; //all subsub categories to show

            // this.activeMain = category;
            this.activeSub = {}; //ACTIVE Subcategory
            this.activeSubSub = {}; // ACTIVE subsub category
            this.page = 1; // page to load
            this.ideas = []; // all loaded ideas
            this.filters.category = {
                main: this.main.id,
                sub: null,
                subsub: null,
            };
            if (!this.mapView) {
                this.$refs.infiniteLoading.stateChanger.reset();
            }
        },
        changeSub(category) {
            console.log("CHANGE SUB", category);
            this.filters.category = {
                main: this.main.id,
                sub: category.id ?? null,
                subsub: null,
            };
            this.subsubs = category.subcategory ?? []; //all subsub categories to show
            this.activeSub = category; //ACTIVE Subcategory
            this.activeSubSub = {}; // ACTIVE subsub category
            this.page = 1; // page to load
            this.ideas = []; // all loaded ideas
            if (!this.mapView) {
                this.$refs.infiniteLoading.stateChanger.reset();
            }
        },
        changeSubSub(category) {
            // console.log("CHANGE", category);
            this.filters.category = {
                main: this.main.id,
                sub: this.filters.category.sub,
                subsub: category.id ?? null,
            };
            this.activeSubSub = category;
            this.page = 1; // page to load
            this.ideas = []; // all loaded ideas

            this.$refs.infiniteLoading.stateChanger.reset();
        },
        changeFilters(filters) {
            this.filters = filters;
            this.read();
        },
    },
    mounted() {
        // window.onpopstate = function (event) {
        //   console.log("test");
        //   console.log("edit main cat", event.state.main);
        //   this.main = event.state.main;
        // };

        if (this.startMap) {
            this.mapView = true;
            this.filters.geolocation = {
                latitude: parseFloat(this.startLat),
                longitude: parseFloat(this.startLng),
            };
        }
        this.subs = this.main.subcategory ?? null;
        this.subsubs = this.mainS ? this.mainS.subcategory : null;
    },
    created() {
        this.debounceFilter = _.debounce(function () {
            console.log("DEBOUNCE FILTER");
            this.page = 1;
            this.ideas = [];
            if (!this.mapView) {
                this.$refs.infiniteLoading.stateChanger.reset();
            }
        }, 500);
    },
    beforeCreate() {
    },
    computed: {
        ideasAmount: function () {
            return this.ideasTotal == 1
                ? this.ideasTotal + " Idee"
                : this.ideasTotal + " Ideen";
        },
    },
};
</script>

<style>
</style>
